import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/store/types';

export interface NotificationsState {
  webPushPermissionState: PermissionState | undefined;
}

export const initialState: NotificationsState = {
  webPushPermissionState: undefined,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setWebPushPermissionState: (
      state,
      action: PayloadAction<PermissionState | undefined>
    ) => {
      state.webPushPermissionState = action.payload;
    },
  },
});

export const { setWebPushPermissionState } = notificationsSlice.actions;

export const selectWebPushPermissionState = (state: RootState) =>
  state.notifications.webPushPermissionState;
